import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Service, ServiceState } from '../../types/service';
import { v4 as uuidv4 } from 'uuid';

const initialState: ServiceState = {
  items: [],
  selectedService: null,
  isLoading: false,
  error: null,
};

const serviceSlice = createSlice({
  name: 'services',
  initialState,
  reducers: {
    addService: (state, action: PayloadAction<Omit<Service, 'id'>>) => {
      const newService = { ...action.payload, id: uuidv4() };
      state.items.push(newService);
    },
    updateService: (state, action: PayloadAction<Service>) => {
      const index = state.items.findIndex(item => item.id === action.payload.id);
      if (index !== -1) {
        state.items[index] = action.payload;
      }
    },
    deleteService: (state, action: PayloadAction<string>) => {
      state.items = state.items.filter(item => item.id !== action.payload);
    },
    setSelectedService: (state, action: PayloadAction<Service | null>) => {
      state.selectedService = action.payload;
    },
  },
});

export const { addService, updateService, deleteService, setSelectedService } =
  serviceSlice.actions;
export default serviceSlice.reducer;
